import { useState } from "react";
import { useParams } from "react-router-dom";
import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";

function Homepage() {
  const params = useParams();

  let dates = "";
  console.log(params.trip);

  switch (params.trip) {
    case "May_20-29":
      dates = "May 20 - 29, 2026";
      break;

    case "trip":
      dates = "";
      break;
  }

  return (
    <div className={styles.backgroundPictureScotland}>
      <div className={styles.titleBox}>
        {/* <h1>
          Come to what many consider to be the most beautiful country in the
          world,
        </h1> */}
        <p className={styles.title}>Scotland</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            Exploring Scotland is like stepping into a captivating storybook,
            where ancient castles stand proudly against the backdrop of rugged
            mountains and shimmering lochs. The itinerary for this tour will
            include Edinburgh, the Scottish Highlands, Inverness, Loch Ness, the
            Islands of Skye, Mull, Iona and more.
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
